import { Component, OnInit } from '@angular/core';

//service
import { GeneralService } from './core/services/general.service'
import { LoginService } from '@core/services/login.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  loading = false;
  eventsNone = false;

  title = 'redcore-web';

  constructor(private generalService: GeneralService) { 
    setTimeout(() => {
      this.generalService.getLoading()
      .subscribe((show:boolean)=> {
        setTimeout(() => {
          this.loading = show
        });
      });
    });
  }

  ngOnInit(): void {

  }


}
